import * as React from "react";
import { observer } from "mobx-react";
import { Icon } from "./Icon";

@observer
export class ChangePasswordIcon extends Icon {

	render() {
		return <Icon {...this.props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
				<circle cx="30" cy="30" r="2" />
				<circle cx="24" cy="30" r="2" />
				<circle cx="18" cy="30" r="2" />
				<path d="M36,20h-2V10c0-1.1-0.9-2-2-2H16c-1.1,0-2,0.9-2,2v10h-2c-1.1,0-2,0.9-2,2v16c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V22C38,20.9,37.1,20,36,20z M16,11c0-0.5,0.5-1,1-1h14c0.5,0,1,0.5,1,1v9H16V11z M36,37c0,0.5-0.5,1-1,1H13c-0.5,0-1-0.5-1-1V23c0-0.5,0.5-1,1-1h3h1h14h1h3c0.5,0,1,0.5,1,1V37z" />
			</svg>
		</Icon>;
	}
}